import homeService from "services/homeService";
import { notification } from "antd";
import L from 'leaflet';
import dayjs from 'dayjs';
import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';

// I want to delete this file. Badly.

// TSR = TimeSeriesRender.
export function handleTSR(setIsTSRButtonClicked, newValue) {
    setIsTSRButtonClicked(newValue);
}

// TSA = TimeSeriesAnimation
export function handleTSA(setIsTSAButtonClicked, newValue) {
    setIsTSAButtonClicked(newValue);
}

//ZST = ZonalStatisticsTool
export async function handleZST(mapRef, mapParameters, startDate, setZSTPopUpContent) {

    if (mapParameters.length === 0) {
        notification.warning({
            message: 'Select a layer and a NUTS region',
            description: 'Select a layer and a NUTS region to use the zonal statistic tool',
            placement: 'top',
            style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
        });
        
        return;
    }

    const dateString = startDate.format('YYYY/MM/DD');
    const dateStringUnderScore = startDate.format('YYYY_MM_DD');

    // arrays for multiple layers
    const file_paths = [];
    const no_data_values = [];
    const layers = [];
    const mapParametersFullArray = [];

    setZSTPopUpContent({
        data: [],
        allData: {},
        currentLayerIndex: 0,
        layerNames: [],
        isLoading: true
    });

    for (const layerParam of mapParameters) {
        const dataLayer = LayersAndResolutions.layers.find(layer => layer.shortName == layerParam.provider);
        const fileExtension = dataLayer.fileExtension;

        const file_path = `DWData/${layerParam.provider}/${layerParam.spaceResolution}/${layerParam.timeResolution}/${dateString}/${layerParam.spaceResolution}_${layerParam.timeResolution}_${dateStringUnderScore}.${fileExtension}`;
        file_paths.push(file_path);

        layers.push('products');
        no_data_values.push(dataLayer.nodata);

        const [year, month, day] = dateString.split('/');
        mapParametersFullArray.push({
            provider: layerParam.provider,
            timeResolution: layerParam.timeResolution,
            spaceResolution: layerParam.spaceResolution,
            mapFilename: layerParam.fileName,
            filename: `${layerParam.spaceResolution}_${layerParam.timeResolution}_${year}_${month}_${day}`,
            dateString: `${year}/${month}/${day}`,
            predictionDate: dayjs(`${year}/${month}/${day}`).format("YYYY_MM_DD"),
            year,
            month,
            day
        });
    }

    let nutsFile = '';
    let nutsId = '';
    const mapserver_url = process.env.REACT_APP_MAP_SERVER_URL;

    Object.values(mapRef.current._layers).forEach((layer) => {
        const { feature } = layer;
        if (feature?.properties?.nutsLevel && feature.properties.selected) {
            nutsFile = feature.properties.nutsLevel;
            nutsId = feature.properties.FID;
        }
    });

    let bbox;

    if (nutsId === '') {
        try {
            const bboxUnformated = await handleDrawRectangleClick(mapRef, setZSTPopUpContent);

            if (!bboxUnformated || !bboxUnformated.southWest || !bboxUnformated.northEast) {
                notification.warning({
                    message: 'Invalid selection',
                    description: 'Please draw a complete bounding box by clicking and dragging.',
                    placement: 'top',
                    style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
                });
                setZSTPopUpContent(null);
                return;
            }

            bbox = [
                bboxUnformated.southWest.lng, // west
                bboxUnformated.southWest.lat, // south
                bboxUnformated.northEast.lng, // east
                bboxUnformated.northEast.lat  // north
            ];

            // Additional validation for bbox values
            if (bbox.some(coord => coord === undefined || isNaN(coord))) {
                notification.warning({
                    message: 'Invalid coordinates',
                    description: 'The selected area contains invalid coordinates. Please try again.',
                    placement: 'top',
                    style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
                });
                setZSTPopUpContent(null);
                return;
            }

            if (bbox[0] === bbox[2] || bbox[1] === bbox[3]) {
                notification.warning({
                    message: 'Invalid area',
                    description: 'Please select an area, not just a point. Click and drag to create a box.',
                    placement: 'top',
                    style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
                });
                setZSTPopUpContent(null);
                return;
            }
        } catch (error) {
            notification.error({
                message: 'Selection error',
                description: 'An error occurred while creating the bounding box. Please try again.',
                placement: 'top',
                style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
            });
            setZSTPopUpContent(null);
            return;
        }
    }

    if (nutsId === '' && (!bbox || bbox.some(coord => coord === undefined || isNaN(coord)))) {
        notification.error({
            message: 'No valid area selected',
            description: 'Please either select a NUTS region or draw a valid bounding box.',
            placement: 'top',
            style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
        });
        setZSTPopUpContent(null);
        return;
    }

    try {
        if (mapParametersFullArray.length > 1) {
            let allData = {};

            for (let i = 0; i < mapParametersFullArray.length; i++) {
                const singleLayerParam = [mapParametersFullArray[i]];
                const layerResult = await homeService.getZonalStatistics(
                    singleLayerParam,
                    [file_paths[i]],
                    nutsId,
                    nutsFile,
                    mapserver_url,
                    [layers[i]],
                    [no_data_values[i]],
                    bbox
                );

                // Group this layer's data
                if (layerResult && layerResult.length > 0) {
                    const layerName = layerResult[0].layerName || `layer_${i}`;
                    allData[layerName] = layerResult;

                    setZSTPopUpContent({
                        data: layerResult,
                        allData: { ...allData },
                        currentLayerIndex: 0,
                        layerNames: Object.keys(allData),
                        progressStatus: `Loaded ${i + 1} of ${mapParametersFullArray.length} layers`
                    });
                }
            }

            setZSTPopUpContent({
                data: allData[Object.keys(allData)[0]] || [],
                allData: allData,
                currentLayerIndex: 0,
                layerNames: Object.keys(allData)
            });
        } else {
            // Single layer
            const zonalData = await homeService.getZonalStatistics(
                mapParametersFullArray,
                file_paths,
                nutsId,
                nutsFile,
                mapserver_url,
                layers,
                no_data_values,
                bbox
            );

            // Group results by layer name
            const groupedData = {};
            zonalData.forEach(item => {
                const layerName = item.layerName || 'unknown';
                if (!groupedData[layerName]) {
                    groupedData[layerName] = [];
                }
                groupedData[layerName].push(item);
            });

            // First layer's data
            const firstLayerName = Object.keys(groupedData)[0];
            setZSTPopUpContent({
                data: groupedData[firstLayerName],
                allData: groupedData,
                currentLayerIndex: 0,
                layerNames: Object.keys(groupedData)
            });
        }
    } catch (error) {
        notification.error({
            message: 'Error fetching zonal statistics',
            description: "There was a problem displaying zonal statistics: " + error.message,
            placement: 'top',
            style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
        });
    } finally {
        setZSTPopUpContent(prevContent => {
            if (prevContent) {
                return { ...prevContent, isLoading: false };
            }
            return prevContent;
        });
    }
}

export const handleDrawRectangleClick = (mapRef, setZSTPopUpContent) => {
    return new Promise((resolve, reject) => {
        try {
            if (!mapRef || !mapRef.current) {
                return reject(new Error('Map reference is not available'));
            }

            const map = mapRef.current;

            let zstDraw = map._zstDraw;
            if (!zstDraw) {
                zstDraw = new L.FeatureGroup([], { name: "ZST" });
                map.addLayer(zstDraw);
            } else {
                zstDraw.clearLayers();
            }

            if (!L.Draw) {
                notification.error({
                    message: 'Drawing tool not available',
                    description: 'The drawing tool is not available. Make sure Leaflet.Draw is properly loaded.',
                    placement: 'top',
                    style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' },
                });
                return reject(new Error('Leaflet.Draw not available'));
            }

            const drawControl = new L.Draw.Rectangle(map, {
                shapeOptions: {
                    color: '#3388ff',
                    weight: 2,
                    opacity: 0.5,
                    fillOpacity: 0.2
                }
            });

            const timeout = setTimeout(() => {
                cleanupListeners();
                reject(new Error('Selection timeout. Please try again.'));
            }, 30000);

            const cleanupListeners = () => {
                map.off('draw:created');
                map.off('draw:canceled');
                clearTimeout(timeout);

                try {
                    if (drawControl && typeof drawControl.disable === 'function') {
                        drawControl.disable();
                    }
                } catch (e) {
                    console.log('Error disabling draw control', e);
                }
            };

            map.once('draw:canceled', () => {
                cleanupListeners();
                
                reject(new Error('Drawing was canceled'));
            });

            map.once('draw:created', (e) => {
                cleanupListeners();

                const layer = e.layer;
                const bounds = layer.getBounds();

                zstDraw.addLayer(layer);
                layer.bindTooltip("Click to remove selection", {
                    sticky: true,
                    opacity: 0.9,
                    className: 'rectangle-tooltip'
                });

                layer.on('click', function() {
                    zstDraw.removeLayer(layer);
                    setZSTPopUpContent(null);
                });

                if (!bounds ||
                    typeof bounds.getSouthWest !== 'function' ||
                    typeof bounds.getNorthEast !== 'function') {
                    reject(new Error('Invalid bounds - bounds object is malformed'));
                    return;
                }

                const sw = bounds.getSouthWest();
                const ne = bounds.getNorthEast();

                if (!sw || !ne ||
                    typeof sw.lat !== 'number' ||
                    typeof sw.lng !== 'number' ||
                    typeof ne.lat !== 'number' ||
                    typeof ne.lng !== 'number' ||
                    isNaN(sw.lat) || isNaN(sw.lng) ||
                    isNaN(ne.lat) || isNaN(ne.lng)) {
                        reject(new Error('Invalid bounds - coordinates are not numbers'));
                        return;
                }

                if (sw.lat === ne.lat || sw.lng === ne.lng) {
                    reject(new Error('Please draw an area, not just a point'));
                    return;
                }

                resolve({
                    southWest: sw,
                    northEast: ne
                });
            });

            drawControl.enable();

            if (window.notification && window.notification.info) {
                window.notification.info({
                    message: 'Draw a rectangle',
                    description: 'Click and drag to draw a rectangle on the map',
                    placement: 'top',
                    duration: 5,
                    style: { backgroundColor: '#fff', color: '#000', borderRadius: '6px' }
                });
            }
        } catch (error) {
            console.error('Error in handleDrawRectangleClick:', error);
            reject(error);
        }
    });
};

export const clearZSTChanges = (mapRef, setZSTPopUpContent) => {
    setZSTPopUpContent(null);
    const layers = mapRef.current.eachLayer((layer) => {
        if(layer instanceof L.FeatureGroup && layer.options.name === 'ZST') {
            layer.clearLayers();
            return;
        }
    });

};